import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M16.841 10a6.042 6.042 0 1 1-12.083 0 6.042 6.042 0 0 1 12.083 0Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M13.508 10c0 3.75-1.673 6.042-2.708 6.042-1.036 0-2.709-2.292-2.709-6.042S9.764 3.958 10.8 3.958c1.035 0 2.708 2.292 2.708 6.042Zm-8.542 0h11.667M17 4 5 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);